export default __webpack_public_path__ + "static/media/Amulet of Crimson Slaughter.7bf586a8.jpg";